import { render } from "./BotoesSalvarCancelar.vue?vue&type=template&id=65f53f2a&scoped=true&ts=true"
import script from "./BotoesSalvarCancelar.vue?vue&type=script&lang=ts"
export * from "./BotoesSalvarCancelar.vue?vue&type=script&lang=ts"

import "./BotoesSalvarCancelar.vue?vue&type=style&index=0&id=65f53f2a&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f53f2a"]])

export default __exports__